import "./user-avatar.css";

interface UserAvatarProps {
    /** URL of the avatar image. Falls back to initial if null/undefined. */
    url: string | null | undefined;
    /** Display name used to derive the fallback initial. */
    name: string;
    /** Diameter in px (default: 32). */
    size?: number;
    /** Additional class names for variant styling (border, background, etc.). */
    className?: string;
}

export function UserAvatar({ url, name, size = 32, className }: UserAvatarProps) {
    const initial = name?.[0]?.toUpperCase() ?? "?";

    return (
        <div
            className={`user-avatar${className ? ` ${className}` : ""}`}
            style={{ width: size, height: size }}
            aria-label={`${name}'s avatar`}
        >
            {url ? (
                <img
                    src={url}
                    alt={`${name}'s avatar`}
                    className="user-avatar__img"
                    loading="lazy"
                />
            ) : (
                <span
                    className="user-avatar__fallback"
                    style={{ fontSize: Math.round(size * 0.4) }}
                >
                    {initial}
                </span>
            )}
        </div>
    );
}
